var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.uploadInProgress)?_c('v-progress-linear',{class:{ 'global-progress--preparing': _vm.waitingForProgress },attrs:{"value":_vm.progress,"indeterminate":_vm.waitingForProgress,"id":"globalProgress","height":"4","color":"#ff4081"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }